import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import LocationImageGallery from '../../locations/contentPages/LocationImageGallery'

const ProjectImages = () => {
	const { id } = useParams()
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin

	const { projectLoading, project } = useSelector(state => {
		return {
			projectLoading: state.projects.isLoading,
			project: state.projects.entities[id],
		}
	})

	// if (projectLoading || !project) return null

	const locationId = project ? project.projectAsset?._id : null

	const { isLoading: loading, location } = useSelector(state => {
		return {
			isLoading: state.locations.isLoading,
			location: state.locations.entities[locationId] || {},
		}
	})

	// TODO: Create skeleton loader
	if (loading || !location) return null
	if (projectLoading || !project) return null

	return <LocationImageGallery user={userInfo} location={location} project={project} />
}

export default ProjectImages
